/**
 * 로그인된 경우에만 접근 가능한 페이지
 */
import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
import AuthGuard from '@routes/guards/AuthGuard';
import { PATHS } from '@routes/paths';
import { CommonLayout } from '@layouts/CommonLayout';

//MAIN
const MainPage = lazy(() => import('@pages/main'));
//BADGE
const BadgeListPage = lazy(() => import('@pages/badge/list'));
const BadgeSettingPage = lazy(() => import('@pages/badge/setting'));
//POINT
const PointListPage = lazy(() => import('@pages/point/list'));
//VOTE
const VoteListPage = lazy(() => import('@pages/vote/list'));
const VoteDetailPage = lazy(() => import('@pages/vote/detail'));
//USER
const UserListPage = lazy(() => import('@pages/user/list'));
const UserDetailPage = lazy(() => import('@pages/user/detail'));

const authRoutes = [
  {
    element: (
      <AuthGuard>
        <Suspense>
          <CommonLayout>
            <Outlet />
          </CommonLayout>
        </Suspense>
      </AuthGuard>
    ),
    children: [
      {
        path: PATHS.main,
        element: <MainPage />,
      },
      {
        path: PATHS.badge.list,
        element: <BadgeListPage />,
      },
      {
        path: PATHS.badge.setting,
        element: <BadgeSettingPage />,
      },
      {
        path: PATHS.point.list,
        element: <PointListPage />,
      },
      {
        path: PATHS.vote.list,
        element: <VoteListPage />,
      },
      {
        path: PATHS.vote.detail,
        element: <VoteDetailPage />,
      },
      {
        path: PATHS.user.list,
        element: <UserListPage />,
      },
      {
        path: PATHS.user.detail,
        element: <UserDetailPage />,
      },
    ],
  },
];

export default authRoutes;
